// extracted by mini-css-extract-plugin
export default {"common":"Common_common__JHTRZ","sidebar":"Common_sidebar__Krkig","component":"Common_component__SuDKv"};